/**
 * Session-scoped UI for the calm timeline-save reminder. Dismissal clears when the
 * browser session ends so the nudge can return on a later visit without feeling permanent.
 */

const DISMISS_KEY_PREFIX = "maatii:tl-remind-dismiss:v1:" as const
const PULSE_KEY_PREFIX = "maatii:tl-remind-pulse:v1:" as const

export function isTimelineSaveReminderDismissedSession(eventId: string): boolean {
  const id = eventId.trim()
  if (!id || typeof window === "undefined") return false
  try {
    return sessionStorage.getItem(DISMISS_KEY_PREFIX + id) === "1"
  } catch {
    return false
  }
}

export function dismissTimelineSaveReminderSession(eventId: string): void {
  const id = eventId.trim()
  if (!id || typeof window === "undefined") return
  try {
    sessionStorage.setItem(DISMISS_KEY_PREFIX + id, "1")
  } catch {
    /* quota / private mode */
  }
}

/** Call when the event becomes saved so a later “remove” surfaces the reminder again. */
export function clearTimelineSaveReminderDismissSession(eventId: string): void {
  const id = eventId.trim()
  if (!id || typeof window === "undefined") return
  try {
    sessionStorage.removeItem(DISMISS_KEY_PREFIX + id)
  } catch {
    /* ignore */
  }
}

/** First show per session may use a one-time soft accent; then mark consumed. */
export function shouldTimelineSaveReminderPulseSession(eventId: string): boolean {
  const id = eventId.trim()
  if (!id || typeof window === "undefined") return false
  try {
    return sessionStorage.getItem(PULSE_KEY_PREFIX + id) !== "1"
  } catch {
    return false
  }
}

export function markTimelineSaveReminderPulseConsumedSession(
  eventId: string,
): void {
  const id = eventId.trim()
  if (!id || typeof window === "undefined") return
  try {
    sessionStorage.setItem(PULSE_KEY_PREFIX + id, "1")
  } catch {
    /* ignore */
  }
}
